"use client";

import clsx from "clsx";
import { FC } from "react";

import { PropsWithTestId } from "../types";

interface Props extends Omit<React.ComponentProps<"input">, "onChange">, PropsWithTestId {
  containerClass?: string;
  onChange?: (_: string) => void;
}

export const TextInput: FC<Props> = ({
  onChange = () => {},
  className = "",
  type = "text",
  containerClass = "",
  disabled = false,
  "data-testid": dataTestId,
  ...props
}) => (
  <div data-component={TextInput.name} className={containerClass}>
    <div className={clsx(
      "relative bg-white flex items-center rounded-md border border-gray-300 shadow-sm focus-within:border-indigo-500 sm:text-sm",
      disabled && "bg-gray-100",
    )}>
      <input
        {...props}
        disabled={disabled}
        type={type}
        onChange={(e) => onChange(e.target.value)}
        className={clsx(
          "placeholder-gray-300 flex-1 border-none appearance-none focus:ring-0 bg-transparent",
          className,
          disabled && "text-gray-400 cursor-not-allowed",
        )}
        data-testid={ dataTestId }
      />
    </div>
  </div>
);
